<main class="min-h-screen bg-white">
  <div class="mx-auto mt-6 w-full max-w-9xl px-5 pt-5 sm:px-6 lg:px-8">
    <!-- Only this area changes when routing -->
    <section class="pt-8">
      <router-outlet />
    </section>

  </div>
</main>
